//JavaScript Document
import React, { Component, Fragment } from "react";

import { root, requestWithSignInJson, getAccessPage } from "../../api";
import { Tabs, Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
const { TabPane } = Tabs;
export default class DataReport extends Component {
  constructor() {
    super();
    this.state = {
      noticeList: [],
      noticeIndex: 1,
      noticeTotalCount: 0,
      announcementList: [],
      announcementIndex: 1,
      announcementTotalCount: 0,
    };
  }
  render() {
    const columns = [
      {
        title: "标题",
        key: "title",
        align: "left",
        render: (text, record, index) => {
          return (
            <Link
              to={`/notifyDetail/${encodeURIComponent(record.content)}`}
              key={record.id}
            >
              <span>{record.title}</span>
            </Link>
          );
        },
      },
      {
        title: "创建时间",
        key: "createTime",
        width: "150px",
        render: (text, record) => {
          return moment(record.createTime).format("YYYY-MM-DD HH:mm:SS");
        },
      },
    ];
    let {
      noticeList,
      noticeIndex,
      noticeTotalCount,
      announcementList,
      announcementIndex,
      announcementTotalCount,
    } = this.state;
    return (
      <div className="notifyList">
        <h1>通知公告</h1>
        <Tabs defaultActiveKey="notice" onChange={this.change}>
          <TabPane tab="通知" key="notice">
            <Table
              dataSource={noticeList}
              rowKey={(record, index) => index}
              pagination={{
                defaultCurrent: 1,
                current: noticeIndex,
                pageSize: 20,
                showQuickJumper: true,
                total: noticeTotalCount,
                onChange: (pageNumber) => this.queryData(1, pageNumber),
              }}
              columns={columns}
            />
          </TabPane>
          <TabPane tab="公告" key="announcement">
            <Table
              dataSource={announcementList}
              rowKey={(record, index) => index}
              pagination={{
                defaultCurrent: 1,
                current: announcementIndex,
                pageSize: 20,
                showQuickJumper: true,
                total: announcementTotalCount,
                onChange: (pageNumber) => this.queryData(2, pageNumber),
              }}
              columns={columns}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
  componentDidMount() {
    this.queryData(1, 1);
    this.queryData(2, 1);
  }
  queryData = (type, pageNumber) => {
    let today = new Date();
    let data = {
      type,
      isScroll: "",
      endTime: `${today.getFullYear()}-${today.getMonth() < 9 ? "0" : ""}${
        today.getMonth() + 1
      }-${today.getDate() < 10 ? "0" : ""}${today.getDate()}`,
    };
    requestWithSignInJson({
      method: "POST",
      url: `${root}/notice/noticeList/${pageNumber}/20`,
      accessPage: getAccessPage({
        module: "通知公告",
        operation: "query",
      }),
      data,
    })
      .then((resp) => {
        let { list, recordTotal } = resp.data;
        type == 1
          ? this.setState({
              noticeIndex: pageNumber,
              noticeTotalCount: recordTotal,
              noticeList: list,
            })
          : this.setState({
              announcementIndex: pageNumber,
              announcementTotalCount: recordTotal,
              announcementList: list,
            });
      })
      .catch((error) => {
        console.log(error);
        // alert("查询出错了~~~");
      });
  };
}
